import { makeInstaller } from './make-installer'
import Components from './component'
import Plugins from './plugin'

export default makeInstaller([
  ...Components,
  ...Plugins,
])
